import service from "@/utils/request"

export function getPageByPoolNumApi(data) {
    return service({
        url: '/packageSystemConfig/getPageByPoolNum',
        method: 'get',
        params:data
    })
}


export function getPoolInfoApi(data) {
    return service({
        url: '/packageSystemConfig/getPoolInfo',
        method: 'get',
        params:data
    })
}


export function editPoolMaxTokenApi(data) {
    return service({
        url: '/packageSystemConfig/editPoolMaxToken',
        method: 'get',
        params:data
    })
}